export default __webpack_public_path__ + "static/media/sandmould.a66fc020.png";